import React, { useEffect, useState } from 'react';
import { Slider } from 'antd';

const ZoomableImageView = ({ src, className = '', initialZoom = 1 }) => {
  const diamondMarker = require('../../assets/svg/Diamond.svg');
  const markerSize = 24;
  const clampedInitial = Math.min(3, Math.max(1, initialZoom));
  const [zoom, setZoom] = useState(clampedInitial);
  const [dragging, setDragging] = useState(false);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const next = Math.min(3, Math.max(1, initialZoom));
    setZoom(next);
    if (next <= 1) setPan({ x: 0, y: 0 });
  }, [src, initialZoom]);

  const changeZoom = (delta) => {
    setZoom((z) => {
      const next = Math.min(3, Math.max(1, +(z + delta).toFixed(2)));
      if (next <= 1) setPan({ x: 0, y: 0 });
      return next;
    });
  };
  const zoomPercent = (zoom - 1) / 2;

  return (
    <div className={`diamond-zoom-view ${className}`} style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
      <div
        style={{
          width: '100%',
          minHeight: 320,
          borderRadius: 10,
          overflow: 'hidden',
          background: '#f3f3f3',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
        onMouseMove={(e) => {
          if (!dragging || zoom <= 1) return;
          setPan({
            x: e.clientX - dragStart.x,
            y: e.clientY - dragStart.y,
          });
        }}
        onMouseUp={() => setDragging(false)}
        onMouseLeave={() => setDragging(false)}
        onSelectStart={(e) => e.preventDefault()}
      >
        <img
          src={src}
          alt=""
          draggable={false}
          onDragStart={(e) => e.preventDefault()}
          onMouseDown={(e) => {
            if (zoom <= 1) return;
            e.preventDefault();
            setDragging(true);
            setDragStart({
              x: e.clientX - pan.x,
              y: e.clientY - pan.y,
            });
          }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`,
            transformOrigin: 'center center',
            cursor: zoom > 1 ? (dragging ? 'grabbing' : 'grab') : 'default',
            userSelect: 'none',
          }}
        />
        <div
          style={{
            position: 'absolute',
            right: 20,
            top: 8,
            bottom: 8,
            width: 10,
            height: '58%',
            borderRadius: 14,
            // background: '#cfd1d6',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '4px 0',
            zIndex: 2,
          }}
        >
          <button
            type="button"
            style={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              border: 'none',
              background: '#4f535b',
              color: '#f5f7fa',
              fontSize: 22,
              lineHeight: '18px',
              padding: 0,
              cursor: 'pointer',
            }}
            onClick={() => changeZoom(0.1)}
          >
            +
          </button>
          <div style={{ height: 180, width: '100%', position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: 6,
                width: 18,
                height: 168,
                transform: 'translateX(-50%)',
                background: '#5b5e66',
                clipPath: 'polygon(50% 0%, 80% 0%, 55% 100%, 45% 100%, 20% 0%)',
              }}
            />
            <img
              src={diamondMarker}
              alt=""
              draggable={false}
              style={{
                position: 'absolute',
                left: '50%',
                top: `${10 + (1 - zoomPercent) * 152}px`,
                width: markerSize + zoomPercent,
                height: markerSize + zoomPercent,
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
              }}
            />
            <Slider
              vertical
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(value) => {
                const next = Array.isArray(value) ? value[0] : value;
                setZoom(next);
                if (next <= 1) setPan({ x: 0, y: 0 });
              }}
              railStyle={{ background: 'transparent' }}
              trackStyle={{ background: 'transparent' }}
              handleStyle={{ opacity: 0 }}
              style={{
                position: 'absolute',
                left: '50%',
                top: 0,
                height: 180,
                margin: 0,
                width: 36,
                transform: 'translateX(-50%)',
              }}
            />
          </div>
          <button
            type="button"
            style={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              border: 'none',
              background: '#4f535b',
              color: '#f5f7fa',
              fontSize: 24,
              lineHeight: '18px',
              padding: 0,
              cursor: 'pointer',
            }}
            onClick={() => changeZoom(-0.1)}
          >
            -
          </button>
        </div>
      </div>
    </div>
  );
};

export default ZoomableImageView;
